<script setup lang="ts">
// PROPS
const { view } = defineProps({
    view: { type: String as PropType<'desktop' | 'mobile'>, required: true },
});

// COMPSABLES
const config = useRuntimeConfig();
const { elfsightDisabled } = config.public;
const { isLgOrGreater } = useResponsive();

useHead({
    script: [
        // Load the script
        ...insertIf(!elfsightDisabled, { src: 'https://static.elfsight.com/platform/platform.js' }),
    ],
});

// DATA
const isVisible = computed(() => (isLgOrGreater.value ? view === 'desktop' : view === 'mobile'));
</script>

<template>
    <template v-if="!elfsightDisabled">
        <div v-if="isVisible" class="flex justify-center" :class="{ 'es-desktop-badge': view === 'desktop' }">
            <!-- Elfsight Google Reviews | Fleequid SDP - Google Reviews -->
            <div
                class="elfsight-app-66880b10-b775-4e98-abec-fb53f1a4942d mx-auto min-h-[102px] min-w-[183px] rounded-lg bg-neutral-100 lg:flex-1"
                data-elfsight-app-lazy
            ></div>
        </div>
    </template>
</template>

<style>
.es-desktop-badge .es-embed-root .es-badge-container {
    flex: 1 1 0;
}
</style>
